import React from "react"
import { convertOBlocksFromText } from "../../../../../../../../../../libs/converter/block-converter/from-text"
import { Buttons } from "../../components/buttons"
import { EDIT_TYPE } from "../../../../../../../../types"
import { ChatStyle } from "../../../../../../../../../../components/templates/chat/components/styles/chat-style"
import { faQuoteLeft } from "@fortawesome/free-solid-svg-icons"
import styled from "styled-components"
import Color from "../../../../../../../../../../style/enum/color"
import TextareaAutosize from "react-textarea-autosize"
import { ChangeEvent } from "react"
import BaseEditor, { IBaseEditorProps } from "../../abstract/base-editor"
import { container } from "../container"

interface IState {
  text: string
  source: string
}

class Component extends BaseEditor<IBaseEditorProps, IState> {
  constructor(props: IBaseEditorProps) {
    super(props)
    this.state = {
      text: this.getContentText(),
      source: (props.content.quote && props.content.quote.source) || "",
    }
    this.changeText = this.changeText.bind(this)
    this.changeSource = this.changeSource.bind(this)
    this.save = this.save.bind(this)
    this.cancel = this.cancel.bind(this)
    this.getContentText = this.getContentText.bind(this)
    this.editMode = this.editMode.bind(this)
  }

  public render() {
    if (!this.props.content.quote) {
      return null
    }

    if (this.props.content._editMetaData.type === EDIT_TYPE.MENU) {
      return (
        <ChatStyle.QUOTATION.Wrapper onClick={this.editMode}>
          <ChatStyle.QUOTATION.StyledIcon icon={faQuoteLeft} />
          <StyledTextTextarea
            placeholder={"引用を入力してください"}
            value={this.state.text}
            onChange={this.changeText}
          />
          <ChatStyle.QUOTATION.Cite>
            出典:
            <StyledCiteInput
              placeholder={"出典を入力してください"}
              value={this.state.source}
              onChange={this.changeSource}
            />
          </ChatStyle.QUOTATION.Cite>
        </ChatStyle.QUOTATION.Wrapper>
      )
    }

    return (
      <>
        <ChatStyle.QUOTATION.Wrapper>
          <ChatStyle.QUOTATION.StyledIcon icon={faQuoteLeft} />
          <StyledTextTextarea
            autoFocus={true}
            placeholder={"引用を入力してください"}
            value={this.state.text}
            onChange={this.changeText}
          />
          <ChatStyle.QUOTATION.Cite>
            出典:
            <StyledCiteInput
              placeholder={"出典を入力してください"}
              value={this.state.source}
              onChange={this.changeSource}
            />
          </ChatStyle.QUOTATION.Cite>
        </ChatStyle.QUOTATION.Wrapper>
        <Buttons save={this.save} cancel={this.cancel} />
      </>
    )
  }

  protected save() {
    if (this.shouldRemoveContent()) {
      return this.props.actions.saveWithRemoveContent(this.props.content.uuid)
    }

    if (this.shouldShallowRemove()) {
      return this.props.actions.saveWithShallowRemoveContent(
        this.props.content.uuid,
      )
    }

    this.props.actions.saveContent({
      ...this.props.content,
      blocks: convertOBlocksFromText(this.state.text.trim()),
      quote: {
        source: this.state.source.trim(),
        relation: "",
      },
    })
  }

  protected cancel() {
    if (this.getContentText() === "") {
      return this.props.actions.cancelWithRemoveContent(this.props.content.uuid)
    }
    this.props.actions.cancelContent(this.props.content.uuid)
  }

  protected shouldShallowRemove() {
    return this.state.text === "" && this.getContentText() !== ""
  }

  protected shouldRemoveContent() {
    return this.state.text === "" && this.getContentText() === ""
  }

  protected setFocus(): void {
    // autoFocus属性で処理する為、無用
  }

  private changeText({ target }: ChangeEvent<HTMLTextAreaElement>) {
    this.setState({
      text: target.value,
    })
  }

  private changeSource({ target }: ChangeEvent<HTMLInputElement>) {
    this.setState({
      source: target.value,
    })
  }

  private getContentText() {
    return this.props.content.blocks.map(block => block.text).join("\n")
  }

  private editMode() {
    this.props.actions.clickContentEditor(this.props.content.uuid)
    this.forceUpdate()
  }
}

export const QuotationEditor = container(Component)

const StyledTextTextarea = ChatStyle.QUOTATION.Text.withComponent(
  TextareaAutosize,
)

const StyledCiteInput = styled.input`
  min-width: 250px;
  background-color: ${Color.TRANSPARENT};
  color: inherit;
  padding: 2px 3px;
  margin-left: 5px;
`
